module.exports = __webpack_public_path__ + "media/images/everfi-homescreen-hero-17ebcc739bbc482361af47129f894205.jpg";